import React from 'react'
import { Link } from 'react-router-dom'

const FooterOne = () => {
    return (
        <footer className="footer py-80">
            <img
                src="assets/images/bg/body-bottom-bg.png"
                alt="BG"
                className="body-bottom-bg"
            />
            <div className="container container-lg">
                <div className="row gy-40">
                    {/* Company Info - 3 columns */}
                    <div className="col-lg-3">
                        <div className="footer-item">
                            <div className="footer-item__logo mb-24">
                                <Link to="/">
                                    <img src="assets/images/logo/logo.png" alt="Paudhawala" height="50" />
                                </Link>
                            </div>
                            <p className="mb-24 text-gray-600">
                                India's largest multivendor marketplace for plants and gardening essentials.
                            </p>
                            <div className="flex-align gap-12 mb-16">
                                <i className="ph-fill ph-map-pin text-main-600 fs-5"></i>
                                <span className="text-gray-600">Hajipur, Bihar - 844101</span>
                            </div>
                            <div className="flex-align gap-12 mb-16">
                                <i className="ph-fill ph-phone-call text-main-600 fs-5"></i>
                                <Link to="tel:+919955859697" className="text-gray-600 hover-text-main-600">
                                    +91 99558 59697
                                </Link>
                            </div>
                            <div className="flex-align gap-12 mb-16">
                                <i className="ph-fill ph-envelope text-main-600 fs-5"></i>
                                <Link to="mailto:contact@paudhawala.com" className="text-gray-600 hover-text-main-600">
                                    contact@paudhawala.com
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Plant Categories - 2 columns */}
                    <div className="col-lg-2">
                        <div className="footer-item">
                            <h6 className="footer-item__title mb-24">Indoor Plants</h6>
                            <ul className="footer-menu">
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Air Purifying</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Succulents</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Flowering Indoor</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Ferns & Foliage</Link></li>
                                <li><Link to="/shop" className="text-gray-600 hover-text-main-600">Low Light Plants</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2">
                        <div className="footer-item">
                            <h6 className="footer-item__title mb-24">Outdoor Plants</h6>
                            <ul className="footer-menu">
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Fruit Plants</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Flowering Shrubs</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Herbal & Medicinal</Link></li>
                                <li className="mb-12"><Link to="/shop" className="text-gray-600 hover-text-main-600">Ornamental Trees</Link></li>
                                <li><Link to="/shop" className="text-gray-600 hover-text-main-600">Palms & Cycads</Link></li>
                            </ul>
                        </div>
                    </div>

                    {/* Quick Links - 2 columns */}
                    <div className="col-lg-2">
                        <div className="footer-item">
                            <h6 className="footer-item__title mb-24">Quick Links</h6>
                            <ul className="footer-menu">
                                <li className="mb-12"><Link to="/about" className="text-gray-600 hover-text-main-600">About Us</Link></li>
                                <li className="mb-12"><Link to="/become-seller" className="text-gray-600 hover-text-main-600">Become a Seller</Link></li>
                                <li className="mb-12"><Link to="/contact" className="text-gray-600 hover-text-main-600">Contact Us</Link></li>
                                <li className="mb-12"><Link to="/blog" className="text-gray-600 hover-text-main-600">Plant Care Blog</Link></li>
                                <li><Link to="/faq" className="text-gray-600 hover-text-main-600">FAQs</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className="footer-item">
                            <h6 className="footer-item__title mb-24">Connect With Us</h6>
                            
                            {/* Social Icons */}
                            <ul className="d-flex gap-12 mb-32">
                                <li>
                                    <Link to="https://facebook.com/paudhawala" 
                                          className="w-40 h-40 flex-center bg-main-100 text-main-600 rounded-circle hover-bg-main-600 hover-text-white">
                                        <i className="ph-fill ph-facebook-logo" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://instagram.com/paudhawala" 
                                          className="w-40 h-40 flex-center bg-main-100 text-main-600 rounded-circle hover-bg-main-600 hover-text-white">
                                        <i className="ph-fill ph-instagram-logo" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://twitter.com/paudhawala" 
                                          className="w-40 h-40 flex-center bg-main-100 text-main-600 rounded-circle hover-bg-main-600 hover-text-white">
                                        <i className="ph-fill ph-twitter-logo" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://youtube.com/paudhawala" 
                                          className="w-40 h-40 flex-center bg-main-100 text-main-600 rounded-circle hover-bg-main-600 hover-text-white">
                                        <i className="ph-fill ph-youtube-logo" />
                                    </Link>
                                </li>
                            </ul>

                            {/* App Store Links */}
                            <h6 className="mb-16">Shop on The Go</h6>
                            <div className="d-flex gap-8">
                                <Link to="https://apple.com/app-store">
                                    <img src="assets/images/thumbs/store-img1.png" alt="App Store" height="40" />
                                </Link>
                                <Link to="https://play.google.com/store">
                                    <img src="assets/images/thumbs/store-img2.png" alt="Google Play" height="40" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterOne